import { Box, Typography } from "@mui/material";
import { useState } from "react";
import Link from "@mui/material/Link";
export const ExpandableDescription = ({ description,characterLimit }: any) => {
    const [expanded, setExpanded] = useState(false);
    const toggleExpand = () => setExpanded(!expanded);
    // const characterLimit = 55;
    const truncatedDescription =
      description.length > characterLimit
        ? `${description.substring(0, characterLimit)}... `
        : description;
  
    return (
      <Box
        sx={{
          display: expanded ? "block" : "flex",
          flexDirection: expanded ? "column" : "row",
          justifyContent: "flex-start",
          alignItems: "center",
        }}
      >
        <Typography variant="body2">
          {expanded ? description : truncatedDescription}
          {description.length > characterLimit && (
            <Link
              component="button"
              variant="body2"
              onClick={toggleExpand}
              sx={{ marginTop: "0px", marginLeft: expanded ? "5px" : "0px", textDecoration: "none" }}
            >
              {expanded ? ` Less` : ` More`}
            </Link>
          )}
        </Typography>
  
      </Box>
    );
  };